<template>
  <v-card>
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">{{ title }}</div>
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="editMode === 'edit' || editMode === 'new'">
            Lista
          </v-tab>
          <v-tab :disabled="!currentItem">Detalle</v-tab>
        </v-tabs>
      </div>
      <div v-show="currentTab === 1">
        <v-btn color="warning" outlined @click="cancel" class="mx-2">
          Cancelar
        </v-btn>
        <v-btn
          v-show="editMode === 'show'"
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editMode !== 'show'"
          color="success"
          outlined
          @click="save"
          clss="mx-2"
        >
          Guardar
        </v-btn>
      </div>
    </v-card>

    <v-card-text v-if="currentTab === 0">
      <paginated-search-table
        endpoint="/data/comunications"
        ordering="-date"
        searchLabel="Asunto"
        :headers="tableHeaders"
        :canEdit="true"
        :canAdd="true"
        :canDelete="true"
        :showSearch="false"
        :canViewDocument="true"
        :key="reloadItems"
        @itemSelected="itemSelected($event, false)"
        @editItem="itemSelected($event, true)"
        @deleteItem="itemDelete($event)"
        @viewDocumentItem="itemViewDocument($event)"
        @add="addNew"
      ></paginated-search-table>
    </v-card-text>
    <div v-if="currentTab === 1">
      <comunication-edit
        :initialMode="editMode"
        :itemURL="currentItem ? currentItem.url : null"
        :key="currentTab"
        @save="save($event)"
        @endEdit="endEdit"
        ref="itemEdit"
      ></comunication-edit>
    </div>
  </v-card>
</template>
<script>
import ComunicationEdit from "@/components/ComunicationEdit";
import PaginatedSearchTable from "@/components/PaginatedSearchTable.vue";

export default {
  name: "Comunication",

  components: {
    PaginatedSearchTable,
    ComunicationEdit
  },

  data: () => ({
    title: "Comunicaciones",
    currentItem: null,
    editMode: null,
    currentTab: 0,
    reloadItems: 0,
    tableHeaders: [
      { text: "Fecha", value: "date", sortable: false },
      {
        text: "Asunto",
        value: "subject",
        sortable: false
      },
      {
        text: "Campaña",
        value: "campaign_code",
        sortable: false
      },
      {
        text: "Requiere Aceptación",
        value: "requires_acceptance_formatted",
        sortable: false
      },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  }),

  methods: {
    itemSelected(args, edit) {
      this.editMode = edit ? "edit" : "show";
      this.currentItem = args;
      this.currentTab = 1;
    },

    async itemDelete(args) {
      if (
        await this.$confirm(
          "Confirme que desea eliminar la comunicación [" + args.subject + "]"
        )
      ) {
        this.$bRoot.delete(args.url);
        this.reloadItems += 1;
      }
    },

    itemViewDocument(args) {
      window.open(args.document, "_blank", "noreferrer");
    },

    addNew() {
      this.currentItem = null;
      this.editMode = "new";
      this.currentTab = 1;
    },

    async cancel() {
      // eslint-disable-next-line
      if(this.editMode === 'show' || await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.endEdit();
      }
    },

    endEdit() {
      this.editMode = null;
      this.currentItem = null;
      this.error = null;
      this.currentTab = 0;
    },

    save() {
      this.$refs.itemEdit.save();
    },

    edit() {
      if (this.currentItem && this.currentTab === 1) {
        this.editMode = "edit";
        this.$refs.itemEdit.mode = "edit";
        this.$refs.itemEdit.editing = true;
      }
    }
  },

  mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.$bRoot.errors = null;
  }
};
</script>
